import { ListCard as ListCardComponent } from './ListCard.component';
import ListCardLoader from './ListCardLoader';

const ListCard = Object.assign(ListCardComponent, { Loading: ListCardLoader });

export default ListCard;
